import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppEntry from "./AppEntry";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppEntry />
  </React.StrictMode>
);
